import { NewselaLogo } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NewselaLogo/NewselaLogo";

export { NewselaLogo };
